import ConfigurationUtils from "./ConfigurationUtils";
import Goals from "./Goals";

export default class PuzzleDataModel {
  constructor(props) {
    this.goal = {};

    Object.keys(Goals).forEach(goal => {
      if (props[goal]) {
        this.goal[goal] = parseInt(props[goal], 10);
      }
    })

    if (props.goalconfiguration) {
      this.goal = PuzzleDataModel.createGoalFromConfigurations(props.goalconfiguration);
    }
  }

  hasCompletedGoal(goal) {
    return this.goal.sigma === goal.sigma &&
      this.goal.ho === goal.ho &&
      this.goal.p === goal.p &&
      this.goal.s === goal.s &&
      this.goal.pi === goal.pi;
  }

  static createGoalFromConfigurations(configurations) {
    if (!Array.isArray(configurations)) {
      configurations = [configurations];
    }
    const newGoal = {};
    const s = configurations.reduce((acc, cur) => acc + ConfigurationUtils.countS(cur), 0);
    if (s) newGoal[Goals.s] = s;

    const p = configurations.reduce((acc, cur) => acc + ConfigurationUtils.countP(cur), 0);
    if (p) newGoal[Goals.p] = p;

    const ho = configurations.reduce((acc, cur) => acc + ConfigurationUtils.countho(cur), 0);
    if (ho) newGoal[Goals.ho] = ho;

    const hasSigma = configurations.length > 1 && configurations.every(config => ConfigurationUtils.isHybridized(config));
    if (hasSigma) {
      newGoal[Goals.sigma] = 1;
      newGoal[Goals.ho] = newGoal[Goals.ho] - 2; // 2 used for the sigma
    }

    return newGoal;
  }

  toString() {
    const sigma = this.goal.sigma ? `sigma: ${this.goal.sigma} ` : '';
    const ho = this.goal.ho ? `ho: ${this.goal.ho} ` : '';
    const p = this.goal.p ? `p: ${this.goal.p} ` : '';
    const s = this.goal.s ? `p: ${this.goal.s} ` : '';
    const pi = this.goal.pi ? `p: ${this.goal.pi} ` : '';

    const str = s + p + pi + sigma + ho;
    return str.trim();
  }
}